import climatizacion from '../../assets/img/climatizacion.png'
import gps from '../../assets/img/gps.png'
import banio from '../../assets/img/banio.png'
import comodidad from '../../assets/img/comodidad.png'
import multimedia from '../../assets/img/multimedia.png'

export const listOptions = [
    {
        id: 1,
        icon: climatizacion,
        name: 'Climatización'
    },
    {
        id: 2,
        icon: multimedia,
        name: 'Multimedia'
    },
    {
        id: 3,
        icon: gps,
        name: 'GPS 24h'
    },
    {
        id: 4,
        icon: comodidad,
        name: 'Comodidad'
    },
    {
        id: 5,
        icon: banio,
        name: 'Baño'
    }
]